module.exports = __webpack_public_path__ + "c3bbb1cbf69d25aba9edc32427e6127a.woff2";


//////////////////
// WEBPACK FOOTER
// ./libs/font-awesome/webfonts/fa-solid-900.woff2
// module id = 355
// module chunks = 0